






























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import {
  ChannelInfo,
  ErrorChannelInfo,
  SuccessChannelInfo
} from '../../../../../../../../../../../../models/CheckChannels/CheckChannels'

@Component({
  data() {
    return {
      SuccessChannelInfo,
    }
  }
})
export default class NotifyGroupActionChannelCard extends Vue {
  @Prop() channelInfo!: ChannelInfo

  get title(): string | null {
    if (this.channelInfo instanceof SuccessChannelInfo) {
      return this.channelInfo.info.title
    }

    if (this.channelInfo instanceof ErrorChannelInfo) {
      return this.channelInfo.value
    }

    return null
  }

  get login(): string | null {
    if (this.channelInfo && this.channelInfo instanceof SuccessChannelInfo && this.channelInfo.info.login) {
      return this.channelInfo.info.login
    }

    return null
  }
}
